/**
 * Dock — 5 element: Bosh · Reyting · **1v1** · Xabar · Profil (SPEC §5).
 *
 * O'rtadagi 1v1 tugmasi KO'TARILGAN (`margin-top:-22px`) — u navigatsiya
 * emas, mahsulotning yadrosi. Prototip 1001.
 *
 * **Faza 1 da uchta tugma o'chiq** (SPEC:351): `Bosh` va `Reyting` room
 * fazasiga tegishli (`rooms_enabled`), `Xabar` esa faza 3 ga. Ular
 * ko'rinadi, lekin bosilganda "tez orada" deydi.
 *
 * Nega umuman ko'rsatiladi: dock mahsulotning shakli haqida va'da beradi
 * — foydalanuvchi bu ilova nima bo'lishini birinchi ekrandayoq ko'radi.
 * D-098 ("o'lik tugma qo'yilmaydi") bunga zid emas: tugma o'lik emas, u
 * javob beradi va nima uchun hali yo'qligini aytadi.
 */

import { useLocation, useNavigate } from 'react-router-dom';

import { uz } from '../i18n/uz';
import { useConfig } from '../lib/config/useConfig';
import { haptic } from '../app/telegram';
import { Icon } from './index';

export function Dock({ onLocked }: { onLocked: (message: string) => void }) {
  const navigate = useNavigate();
  const { pathname } = useLocation();
  const { data: config } = useConfig();

  // Flag serverdan (qoida 23). Yoqilganda tugmalar o'z-o'zidan ochiladi
  // va bu yerda deploy kerak bo'lmaydi.
  const roomsOn = config?.flags['rooms_enabled'] === true;

  function go(path: string): void {
    haptic('light');
    navigate(path);
  }

  function locked(message: string): void {
    haptic('light');
    onLocked(message);
  }

  return (
    <nav className="dock blur-dock" aria-label={uz.dock.label}>
      <DockItem
        icon="home"
        label={uz.dock.home}
        active={pathname === '/'}
        onClick={() => (roomsOn ? go('/') : locked(uz.dock.roomsSoon))}
      />
      <DockItem
        icon="trophy"
        label={uz.dock.top}
        active={pathname === '/top'}
        onClick={() => (roomsOn ? go('/top') : locked(uz.dock.roomsSoon))}
      />

      {/* Markaz — navigatsiya elementi EMAS, shuning uchun boshqa shakl. */}
      <div className="dock__center">
        <button type="button" className="dock__match" onClick={() => go('/match')}>
          <Icon name="match" size={19} />
          <span>{uz.dock.match}</span>
        </button>
      </div>

      {/* Faza 3 da ochildi — endi "tez orada" emas. */}
      <DockItem
        icon="chat"
        label={uz.dock.chats}
        active={pathname === '/chats'}
        onClick={() => go('/chats')}
      />
      <DockItem
        icon="user"
        label={uz.dock.profile}
        active={pathname === '/profile'}
        onClick={() => go('/profile')}
      />
    </nav>
  );
}

function DockItem({
  icon,
  label,
  active,
  onClick,
}: {
  icon: 'home' | 'trophy' | 'chat' | 'user';
  label: string;
  active: boolean;
  onClick: () => void;
}) {
  return (
    <button
      type="button"
      className={active ? 'dock__item dock__item--on' : 'dock__item'}
      aria-current={active ? 'page' : undefined}
      onClick={onClick}
    >
      <Icon name={icon} size={20} />
      <span>{label}</span>
    </button>
  );
}
